import React from "react";

const PageNotFond = () => (
  <section className="max-w-2xl mx-auto py-12 px-4">
    <h1 className="text-3xl font-bold text-center mb-6 text-gray-900 uppercase">
        Pagina no encontrada
    </h1>

  </section>
);

export default PageNotFond;
